import { createContextFromData, BootstrapDataInterface } from 'models/Bootstrap';
import { get } from 'services/http';

export const getBootstrap = () =>
    get<BootstrapDataInterface>('/xhr/bootstrap.json').then(response => createContextFromData(response.data));
